import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import './Layout.css';

export default function Layout() {
  const { isAuthenticated, user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-container">
          <Link to="/" className="layout-logo">
            4mal
          </Link>
          <nav className="layout-nav">
            {isAuthenticated && user && ['Moderator', 'Admin'].includes(user.role) ? (
              <>
                <Link to="/farms">Фермы</Link>
                <Link to="/animals">Животные</Link>
                {user.role === 'Admin' && (
                  <Link to="/admin">Админ-панель</Link>
                )}
                <Link to="/profile">Профиль</Link>
                <button onClick={handleLogout} className="layout-logout">
                  Выйти
                </button>
              </>
            ) : isAuthenticated ? (
              <>
                <button onClick={handleLogout} className="layout-logout">
                  Выйти
                </button>
              </>
            ) : (
              <>
                <Link to="/login">Войти</Link>
                <Link to="/register">Регистрация</Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="layout-main">
        <Outlet />
      </main>
      <footer className="layout-footer">
        <div className="layout-container">
          <div>© NEW SERVICE LTD</div>
          <div className="layout-footer-links">
            <a href="/links/user_agreement_rules_of_use_of_the_application.html">
              Полное соглашение
            </a>
            <a href="/links/terms_and_privacy.html">
              Полная политика конфиденциальности
            </a>
            <a href="/links/newserviceltd.html">Информация о компании</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
